export const faqs = [
  {
    q: 'Is the estimate really free?',
    a: 'Yes. We come out, look at your property, and give you a clear price at no cost and with no obligation to hire us.',
  },
  {
    q: 'How soon can you start?',
    a: 'It depends on the season and the size of the job, but most projects are scheduled within a week or two of approving the estimate. Smaller jobs can often be done sooner.',
  },
  {
    q: 'What areas do you serve?',
    a: 'Forney, Crandall, Sunnyvale, Mesquite, Rockwall, Waxahachie, Rowlett, Plano, Wayne, and nearby communities in North Dallas. If you’re close by, just ask.',
  },
  {
    q: 'Do you work on both homes and businesses?',
    a: 'Yes. We handle residential yards as well as commercial property maintenance and hardscaping.',
  },
  {
    q: 'Do I need to be home during the work?',
    a: 'Not usually. As long as we have access to the work area, we can get the job done and send you photos when we finish.',
  },
  {
    q: 'What happens if it rains?',
    a: 'We keep an eye on the forecast and will reschedule if weather would affect the quality of the work. We’ll always let you know by text.',
  },
  {
    q: 'Do you guarantee your work?',
    a: 'Yes. If something isn’t right with the work we did, call us and we’ll come back and fix it.',
  },
  {
    q: 'Can I send photos of my yard first?',
    a: 'Absolutely. Use the Free Estimate form to attach photos — it helps us give you a more accurate price before we visit.',
  },
];
